<template>
  <Modal :title="$t('key1000284')" v-model="dialogVisible" width="1200px" class="chose-category-box" :transfer="false" :mask-closable="false">
    <p class="chose-category-text" v-if="isSave">{{ $t('key1000285') }}<span class="font-weight">{{ activeText.join('->') }}</span></p>
    <Row :gutter="20">
      <Col :span="6" v-for="(item,index) in list">
        <Card class="box-card" dis-hover>
          <Input v-model.trim="item.search" style="line-height: 36px;" clearable @on-change="inputChange($event,index)"></Input>
          <ul class="chose-box" v-if="item.children && item.children.length > 0">
            <Spin size="large" fix v-if="loading[index]"></Spin>
            <li class="chose-category"
              v-for="(ch,cIndex) in item.children"
              :class="{'item-active':ch.active,'category-arr':ch.isLeaf === 'N'}"
              :title="ch.categoryName"
              @click="getCategoryChildren(ch,index+1, cIndex)"
            >{{ ch.categoryName }}
            </li>
          </ul>
        </Card>
      </Col>
    </Row>
    <template #footer>
      <span class="dialog-footer">
      <Button @click="dialogVisible = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="!isSave" @click="saveHandel">{{ $t('key1000111') }}</Button>
    </span>
    </template>

  </Modal>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'choseCategory',
  mixins: [Mixin],
  data() {
    return {
      isSave: false,
      saveData: {
        cateSeqId: '',
        categoryId: '',
        rootCategoryId: '',
        label: ''
      },
      type: '',
      rootCategoryId: '',
      dialogVisible: false,
      list: [{
        search: '',
        children: []
      }],
      loading: [false],
      activeText: []
    };
  },
  created() {

  },
  props: {
    siteId: {
      type: String
    },
    platformId: {
      type: String
    },
    currentIndex: {
      type: Number
    }
  },
  watch: {},
  methods: {
    /**
     * type 类型
     * @date: 2021/7/9 13:49
     */
    open(type, platformId, siteId) {
      let v = this;
      v.type = type;
      v.list.splice(0, v.list.length, {
        search: '',
        children: []
      });
      v.activeText = [];
      v.isSave = false;
      v.dialogVisible = true;
      if (platformId) {
        v.platformId = platformId;
        v.siteId = siteId;
      }
      v.init();
    },
    saveHandel() {
      this.$emit('save', {
        ...this.saveData,
        type: this.type
      }, this.currentIndex);
      this.dialogVisible = false;
    },
    init() {
      let v = this;
      v.getCategoryList(
        {
          "parentCategoryId": "",
          "platformId": v.platformId,
          "siteId": v.siteId
        }, 0).then(data => {
        v.$set(v.list[0], 'children', data);
        v.$set(v.list[0], 'original', JSON.parse(JSON.stringify(data)));
      }, 0);
    },
    /**
     * @param index 外层
     * @param cIndex 里层
     * */
    setActive(index, cIndex) {
      this.list[index].children.forEach(i => i.active = false);
      let obj = this.list[index].children;
      obj[cIndex].active = true;
      this.$set(this.list[index], 'children', obj);
      this.activeText[index] = this.list[index].children[cIndex].categoryName;
    },
    getCategoryChildren(item, index, cIndex) {
      let v = this;
      v.setActive(index - 1, cIndex);
      v.isSave = false;
      v.list.splice(index, v.list.length - index);
      if (index === 1) {
        v.rootCategoryId = item.categoryId;
      }
      if (item.isLeaf === 'Y') {
        v.activeText.splice(index - 1, (v.activeText.length - v.list.length + 1), item.categoryName);
        v.saveData = {
          ...item
        };
        v.saveData.categoryId = item.categoryId;
        v.saveData.rootCategoryId = v.rootCategoryId;
        v.saveData.cateSeqId = item.cateSeqId;
        v.saveData.label = v.activeText.join('->');
        v.isSave = true;

        return;
      }
      this.loading[index] = false;
      v.getCategoryList({
        'siteId': v.siteId, platformId: v.platformId, 'parentCategoryId': item.categoryId, 'level': index + 1 + ''
      }).then(data => {
        if (index < v.list.length) {
          v.activeText.splice(index, v.activeText.length - index);
        }
        v.$set(v.list, index, {
          children: [],
          original: [],
          search: ''
        });
        v.$set(v.list[index], 'children', data);
        v.$set(v.list[index], 'original', JSON.parse(JSON.stringify(data)));
      }, index);
    },
    inputChange(e, index) {
      this.$set(this.list[index], 'children', this.list[index].original.filter(i => i.categoryName.includes(e.target.value)));
    },
    getCategoryList(params, index) {
      let v = this;
      return new Promise(resolve => {
        v.loading[index] = true;
        v.axios.post(api.post_listing_queryCategory, params, {loading: true}).then(response => {
          if (response.data.code === 0) {
            v.loading[index] = false;
            resolve(response.data.datas);
          }
        });
      });
    }
  }
};
</script>

<style>
.chose-category-box .el-dialog__body {
  padding-top: 10px;
}
</style>
<style scoped>
ul {
  margin: 0;
  padding: 0;
}

.box-card {
  height: 360px;
  margin-bottom: 20px;
}

.item-active {
  background-color: #d8ebf5 !important;
}

.chose-box {
  max-height: 270px;
  width: 100%;
  margin-top: 10px;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #CCCCCC;
  overflow-y: auto;

}

.category-arr:after {
  content: '>';
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  font-family: cursive;
}

.chose-category {
  color: #333;
  line-height: 30px;
  list-style: none;
  /*border-bottom: 1px solid #9e9e9e;*/
  padding: 5px 15px 5px 5px;
  /*background-color: #f4f4f5;*/
  position: relative;
  cursor: pointer;
}

.chose-category:last-child {
  border-bottom: none
}

.chose-category:hover {
  background-color: #e3e3ea;
}

.chose-category-text {
  font-size: 16px;
  padding: 6px 0;
}

</style>
